<template>
  <div>
    <p v-if="contact" class="comm_item--contact" @click="openContactModal">{{ $utils.displayFullName(contact.full_name) }}</p>
    <p v-else class="comm_item--contact_delete">Contact Deleted</p>

    <app-record
        v-if="record"
        :record="record"
        class="comm_item--record"
        one-line
    ></app-record>
  </div>
</template>

<script>
import router from "../../../router";

export default {
  name: "CommunicationItemRecords",
  props: {
    communicationLog: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      maxRecords: 3,
      recordCount: 0,
    }
  },
  computed: {
    record() {
      return this.communicationLog.record;
    },
    contact() {
      return this.communicationLog.contact;
    }
  },
  methods: {
    openContactModal() {
      router.replace({query: {contact: this.contact.id}});
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.comm_item {

  &--contact {
    color: $secondary;
    font-weight: bold;
    cursor: pointer;

    &:hover {
      color: $primary;
    }
  }

  &--contact_delete {
    color: $text-light;
    font-style: italic;
  }

  &--extra_records {
    margin-top: 6px;
    font-size: 0.75rem;
    color: $text-muted;
  }

  &--record {
    margin-top: 8px;
  }
}
</style>
